import * as React from "react";
import classes from "./FacilityCard.module.css";
import { getIconByScope, getSiteByScopeId } from "../../../../utils/UsersUtils";
import { useSelector } from "react-redux";

const FacilityRoleCard = (props) => {
  const sites = useSelector((state) => state.user.sites);
  const scope = props.scope;
  const site = getSiteByScopeId(sites, scope.id);
  
  return (
    <div className={classes.facilityContainer}>
      <div className={classes.cardContent}>
        {getIconByScope(sites, scope, classes.siteIcon)}
        <div className={classes.cardInfo}>
          <span className={classes.siteName}>{site ? site.displayName : scope.name}</span>
          <span className={classes.siteAddress}>{site ? site.address : null}</span>
          <span className={classes.userType}>{props.roleName}</span>
        </div>
      </div>
    </div>
  );
};

export default FacilityRoleCard;
